import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _flatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat";import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";function ownKeys(object, enumerableOnly) {var keys = _Object$keys(object);if (_Object$getOwnPropertySymbols) {var symbols = _Object$getOwnPropertySymbols(object);enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {return _Object$getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));});}return target;}import React, { useEffect, useState } from 'react';

import Sidebar from "../../Sidebar";
import { createStyles } from "./styles";
import RangeSlider from "../RangeSlider";
import FilterSection from "../FilterSection";
import FilterCheckboxOption from "../FilterCheckboxOption";
import ProductLineSwitcher from "../ProductLineSwitcher/index";
import GroupInfoSection from "../GroupInfoSection";

var FilterSidebar = function FilterSidebar(_ref)












{var _context5, _context7;var marketingTags = _ref.marketingTags,productLineAttributes = _ref.productLineAttributes,rates = _ref.rates,productLineIds = _ref.productLineIds,groupInfo = _ref.groupInfo,shouldBeReset = _ref.shouldBeReset,activeProductLineId = _ref.activeProductLineId,_ref$type = _ref.type,type = _ref$type === void 0 ? 'browsing' : _ref$type,filterPortfolios = _ref.filterPortfolios,onProductLineChange = _ref.onProductLineChange,defaultFilters = _ref.defaultFilters,_ref$className = _ref.className,className = _ref$className === void 0 ? '' : _ref$className;
  var classes = createStyles();

  var _useState = useState(
    defaultFilters || { rates: [], tag: [] }),_useState2 = _slicedToArray(_useState, 2),filterValues = _useState2[0],setFilterValues = _useState2[1];


  useEffect(function () {
    // It is called for reset filter options on page component
    if (shouldBeReset) {
      setFilterValues({ rates: [], tag: [] });
      filterPortfolios({ rates: [], tag: [] });
    }
  }, [shouldBeReset]);

  useEffect(function () {
    // filterPortfolios is called to send all updated filters
    if (defaultFilters) {
      filterPortfolios(filterValues);
    }
  }, []);

  // filter onChange callbacks
  var onBooleanCheckboxChange = function onBooleanCheckboxChange(filterName, filterValue) {
    if (!filterValue) {
      var filteredObj = _objectSpread({}, filterValues);
      delete filteredObj[filterName];
      // Call filterPortfolios in each onChange function to avoid loop rerender if it is in useEffect
      filterPortfolios(filteredObj);
      setFilterValues(filteredObj);
      return;
    }

    filterPortfolios(_objectSpread(_objectSpread({}, filterValues), {}, _defineProperty({}, filterName, filterValue)));
    setFilterValues(_objectSpread(_objectSpread({}, filterValues), {}, _defineProperty({}, filterName, filterValue)));
  };

  // processes data for a group of checkboxes (tags, attributes with a type "valueCheckbox")
  var onGroupCheckboxChange = function onGroupCheckboxChange(filterName, filterValue) {var _context;
    var currentSectionValues = filterValues[filterName] || [];

    var checkboxStatus = _flatInstanceProperty(_context = _Object$entries(filterValue)).call(_context);

    if (checkboxStatus[1]) {var _context2;
      var updatedFilters = _objectSpread(_objectSpread({},
      filterValues), {}, _defineProperty({},
      filterName, _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(currentSectionValues), [checkboxStatus[0]])));

      filterPortfolios(updatedFilters);
      setFilterValues(updatedFilters);
    } else {
      // if checkbox is not selected - remove value from list
      var filteredValues = _filterInstanceProperty(currentSectionValues).call(currentSectionValues, function (item) {return item !== checkboxStatus[0];});
      var _updatedFilters = _objectSpread(_objectSpread({},
      filterValues), {}, _defineProperty({},
      filterName, filteredValues));

      filterPortfolios(_updatedFilters);
      setFilterValues(_updatedFilters);
    }
  };

  var onRateChange = function onRateChange(filterName, filterValue) {var _context3, _context4;
    var ratesWithoutCurrent = _filterInstanceProperty(_context3 = filterValues.rates).call(_context3,
    function (rate) {return _Object$keys(rate)[0] !== filterName;});

    var updatedFilters = _objectSpread(_objectSpread({},
    filterValues), {}, {
      rates: _concatInstanceProperty(_context4 = []).call(_context4, _toConsumableArray(ratesWithoutCurrent), [_defineProperty({}, filterName, filterValue)]) });

    filterPortfolios(updatedFilters);
    setFilterValues(updatedFilters);
  };

  var onRangeChange = function onRangeChange(filterName, filterValue) {
    var updatedFilters = _objectSpread(_objectSpread({}, filterValues), _defineProperty({}, filterName, filterValue));
    filterPortfolios(updatedFilters);
    setFilterValues(updatedFilters);
  };

  var valueCheckboxes = _filterInstanceProperty(productLineAttributes).call(productLineAttributes,
  function (attr) {return attr && attr.type === 'valueCheckbox';});


  var booleanCheckboxes = _filterInstanceProperty(productLineAttributes).call(productLineAttributes,
  function (attr) {return attr && attr.type === 'booleanCheckbox';});

  var ranges = _filterInstanceProperty(productLineAttributes).call(productLineAttributes, function (attr) {return attr && attr.type === 'rangeValue';});

  // Filter Components
  var Tags = _mapInstanceProperty(_context5 = _filterInstanceProperty(marketingTags).call(marketingTags,
  function (_ref3) {var productLines = _ref3.productLines;
    return (
      !productLines ||
      productLines.length === 0 ||
      activeProductLineId && _includesInstanceProperty(productLines).call(productLines, activeProductLineId));

  })).call(_context5,
  function (_ref4) {var id = _ref4.id,tag = _ref4.tag;return /*#__PURE__*/(
      React.createElement(FilterCheckboxOption, {
        key: id,
        id: id,
        label: tag,
        displayName: "tag",
        onGroupCheckboxChange: onGroupCheckboxChange,
        attributeType: "tag",
        shouldBeReset: shouldBeReset,
        defaultFilters: defaultFilters }));});



  var OtherSectionCheckboxes = _mapInstanceProperty(booleanCheckboxes).call(booleanCheckboxes, function (_ref5) {var displayName = _ref5.displayName,id = _ref5.id;
    return /*#__PURE__*/(
      React.createElement(FilterCheckboxOption, {
        key: id,
        label: displayName,
        onFilterChange: onBooleanCheckboxChange,
        attributeType: "booleanCheckbox",
        shouldBeReset: shouldBeReset,
        defaultFilters: defaultFilters }));


  });

  var ValueCheckboxesSection = _mapInstanceProperty(valueCheckboxes).call(valueCheckboxes, function (attr) {var _attr$properties, _context6;
    if (!(attr !== null && attr !== void 0 && (_attr$properties = attr.properties) !== null && _attr$properties !== void 0 && _attr$properties.checkboxLabels)) return [];

    var checkboxes = _mapInstanceProperty(_context6 = attr.properties.checkboxLabels).call(_context6, function (property) {
      return /*#__PURE__*/(
        React.createElement(FilterCheckboxOption, {
          key: property,
          label: property,
          displayName: attr.displayName,
          onGroupCheckboxChange: onGroupCheckboxChange,
          attributeType: "valueCheckbox",
          shouldBeReset: shouldBeReset,
          defaultFilters: defaultFilters }));


    });

    return /*#__PURE__*/(
      React.createElement(React.Fragment, { key: attr.id },
      checkboxes.length > 0 && /*#__PURE__*/
      React.createElement(FilterSection, { sectionTitle: attr.displayName }, checkboxes)));



  });

  var PlanAttributesRanges = _mapInstanceProperty(ranges).call(ranges, function (attr) {var _attr$properties2, _attr$properties3, _attr$properties4;
    if (!(attr !== null && attr !== void 0 && (_attr$properties2 = attr.properties) !== null && _attr$properties2 !== void 0 && _attr$properties2.rangeMax)) return /*#__PURE__*/React.createElement(React.Fragment, null);
    return /*#__PURE__*/(
      React.createElement(RangeSlider, {
        key: attr.id,
        min: Number((attr === null || attr === void 0 ? void 0 : (_attr$properties3 = attr.properties) === null || _attr$properties3 === void 0 ? void 0 : _attr$properties3.rangeMin) || 0),
        max: Number(attr === null || attr === void 0 ? void 0 : attr.properties.rangeMax),
        step: Number((attr === null || attr === void 0 ? void 0 : (_attr$properties4 = attr.properties) === null || _attr$properties4 === void 0 ? void 0 : _attr$properties4.step) || 1),
        title: attr.displayName,
        shouldBeReset: shouldBeReset,
        onRangeChange: onRangeChange,
        defaultFilters: defaultFilters }));


  });

  var RatesRanges = _mapInstanceProperty(_context7 = _Object$entries(rates)).call(_context7, function (_ref6) {var _context8;var _ref7 = _slicedToArray(_ref6, 2),key = _ref7[0],range = _ref7[1];
    var defaultRateRange = defaultFilters === null || defaultFilters === void 0 ? void 0 : _findInstanceProperty(_context8 = defaultFilters.rates).call(_context8, function (rate) {return _Object$keys(rate)[0] === key;});
    return /*#__PURE__*/(
      React.createElement(RangeSlider, {
        key: key,
        min: range[0],
        max: range[1],
        title: key,
        step: null,
        hasSmallView: true,
        shouldBeReset: shouldBeReset,
        onRangeChange: onRateChange,
        defaultRateRange: defaultRateRange ? _Object$values(defaultRateRange)[0] : undefined }));


  });

  return /*#__PURE__*/(
    React.createElement(Sidebar, { width: "25rem", className: _filterInstanceProperty(classes), wrapperClassName: className }, /*#__PURE__*/
    React.createElement(FilterSection, null, /*#__PURE__*/
    React.createElement(GroupInfoSection, { groupInfo: groupInfo, type: type })), /*#__PURE__*/

    React.createElement(FilterSection, null, /*#__PURE__*/
    React.createElement(ProductLineSwitcher, {
      onChange: onProductLineChange,
      productLineIds: productLineIds,
      activeProductLineId: activeProductLineId })),



    Tags.length > 0 && /*#__PURE__*/React.createElement(FilterSection, { sectionTitle: "Tags" }, Tags),
    RatesRanges.length > 0 && /*#__PURE__*/
    React.createElement(FilterSection, { sectionTitle: "Monthly Cost" }, RatesRanges),

    PlanAttributesRanges.length > 0 && /*#__PURE__*/
    React.createElement(FilterSection, { sectionTitle: "Plan Attributes" }, PlanAttributesRanges),


    ValueCheckboxesSection,
    OtherSectionCheckboxes.length > 0 && /*#__PURE__*/
    React.createElement(FilterSection, { sectionTitle: "Other" }, OtherSectionCheckboxes)));



};

export default FilterSidebar;
//# sourceMappingURL=index.js.map